import TreeNodeUtils from 'tree-node-utils';
import { fromJS } from 'immutable';
import { mapKeys } from 'lodash';

/**
 * Format the answer data to use in the API
 * Adds _ before key name
 *
 * @param {Object} answers
 */
export const formattedAnswersForAPI = ( answers ) => {
	const formatted = answers.map( ( answer ) => {
		return mapKeys( answer, ( value, key ) => {
			return '_' + key;
		} );
	} );
	return formatted;
};

/**
 * Calculate the points for answers
 *
 * @param {Object} answers
 */
export const calculatePoints = ( answers ) => {
	const answerObject = answers[ 0 ];
	let points = 1,
		maxPoints = 0;

	if ( answerObject ) {
		if ( 'assessment_answer' === answerObject.answerType ) {
			const items = answerObject.answer.match( /{(.*?)}/im );

			if ( items && 0 !== items.length && items[ 1 ] ) {
				points = items[ 1 ].match( /\[([^|\]]+)(?:\|(\d+))?\]/gim )
					.length;
				maxPoints = Math.max( maxPoints, points );
			}
		} else {
			points = answerObject.points;
		}
	}

	return { points, maxPoints };
};

// Tree utils
export const treeConfig = {
	childrenField: 'tree',
	keyField: 'ID',
};
export const treeNodeUtils = new TreeNodeUtils( treeConfig );

/**
 * Concatenates 2 arrays without any duplicates, based on the ID attribute.
 *
 * @param {Array} nodes
 * @param {Array} newNodes
 */
export const mergeUniqueItems = ( nodes, newNodes ) => {
	newNodes.map( ( data ) => {
		const existingElement = nodes.findIndex( ( node ) => {
			node.ID === data.ID;
		} );

		if ( -1 === existingElement ) {
			nodes = [ ...nodes, data ];
		}
	} );

	return nodes;
};

/**
 * Get the parent path for a node, provide the ID.
 *
 * @param {Array}   data       Array
 * @param {number}  ID         Number The id we are looking for
 * @param {boolean} appendTree Whether to add the tree path to the first path.
 *
 * @return {Array} to be used with immutable JS
 */
export const getNodePath = ( data, ID, appendTree = false ) => {
	const immutableData = fromJS( data );
	const parentIndex = immutableData.findIndex(
		( node ) => node.get( 'ID' ) === ID
	);
	let path = -1;

	if ( -1 === parentIndex ) {
		// look into child now
		immutableData.forEach( ( parent, index ) => {
			const parentTree = parent.get( 'tree' );

			if ( parentTree.size ) {
				const childIndex = parentTree.findIndex(
					( node ) => node.get( 'ID' ) === ID
				);

				if ( -1 !== childIndex ) {
					path = [ index, 'tree', childIndex ];
				} else {
					parent.get( 'tree' ).forEach( ( child, childIndex ) => {
						const childTree = child.get( 'tree' );

						if ( childTree && childTree.size ) {
							const grandChildIndex = childTree.findIndex(
								( node ) => node.get( 'ID' ) === ID
							);

							if ( -1 !== grandChildIndex ) {
								path = [
									index,
									'tree',
									childIndex,
									'tree',
									grandChildIndex,
								];
							}
						}
					} );
				}
			}
		} );
	} else {
		path = [ parentIndex ];
	}

	if ( -1 !== path && appendTree ) {
		path.push( 'tree' );
	}

	return path;
};
